import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useSiteWithLocalTime = (projectId: string, siteId: string, mayRequest: boolean = true) => {
  const p = ENDPOINTS.SITES.byIdLocalTime(projectId, siteId)

  const { data, error, mutate } = useSWR(mayRequest ? p : null, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
